var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPath13479(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.216,
    height: 25.089,
    viewBox: "0 0 28.216 25.089",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13479",
    "data-name": "Path 13479",
    d: "M99.03,56a.941.941,0,0,0,0,1.882h3l3.234,15.26c.128.574.5,1.052.98,1.049h15.681a.941.941,0,1,0,0-1.882H107.008l-.4-1.882h16.573a.97.97,0,0,0,.911-.735l2.2-9.408a.985.985,0,0,0-.911-1.147H104.224l-.51-2.391a.971.971,0,0,0-.921-.745Zm5.586,5.018h19.572l-1.754,7.527h-16.22Zm4.763,13.8a3.136,3.136,0,1,0,3.136,3.136A3.15,3.15,0,0,0,109.379,74.817Zm9.408,0a3.136,3.136,0,1,0,3.136,3.136,3.15,3.15,0,0,0-3.136-3.136ZM109.379,76.7a1.254,1.254,0,1,1-1.254,1.254A1.24,1.24,0,0,1,109.379,76.7Zm9.408,0a1.254,1.254,0,1,1-1.254,1.254A1.24,1.24,0,0,1,118.788,76.7Z",
    transform: "translate(-98.089 -56)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath13479);
export default __webpack_public_path__ + "static/media/Path-13479.a40d450e14c20beb8e321cbda9afab10.svg";
export { ForwardRef as ReactComponent };